<template>
	<v-combobox
			dense
			:error="errorBorder"
			:error-messages="error"
			:hide-details="hideDetails"
			:chips="true"
			:deletable-chips="true"
			:items="options"
			:readonly="readonly"
			:label="$props.label"
			:hint="$props.hint"
			multiple
			v-model="selectedValue"
			outlined
	></v-combobox>
</template>

<script>
	export default {
		name: "Tags",
		props: {
			readonly: Boolean,
			value: Array,
			ajax: Boolean,
			data: [Array, String],
			label: String,
			hint: {
				type: String,
				default: ''
			},
			errorBorder: {
				type: Boolean,
				default: false
			},
			error: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				endpoint: '',
				selectedValue: null,
				options: [],
				ajaxLoaded: false
			}
		},
		computed: {
			hideDetails() {
				return this.$props.hint === '' && this.$props.error === '';
			}
		},
		watch: {
			value: function (newVal, oldVal) {
				if (newVal != oldVal) {
					if (newVal != null) {
						if (this.selectedValue != null) {
							if (this.selectedValue.value != newVal) {
								this.setValue(newVal);
							}
						} else {
							this.setValue(newVal);
						}
					} else {
						this.selectedValue = null;
					}
				}
			},
			selectedValue: function (val) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						})
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					})
				}
				this.$nextTick(() => {
					this.callChange();
				});
			},
		},
		methods: {
			callChange() {
				this.$emit('changes');
			},
			setValue(newVal) {
				if (this.$props.ajax) {
					if (!this.ajaxLoaded) {
						var vm = this;
						this.$APICall('get', 'tags/' + this.endpoint, [], function (data) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}, false);
					} else {
						this.selectedValue = newVal;
					}
				} else {
					this.options = this.$props.data;
					this.selectedValue = newVal;
				}
			}
		},
		mounted() {
			if (this.$props.ajax) {
				this.endpoint = this.$props.data;
			}
			this.setValue(this.$props.value);
		}
	}
</script>

<style scoped>

</style>
